import { IoIosClose } from 'react-icons/io';
import styles from './styles/voca.module.css';

export default function Voca({ id, index, useWord, updateMode, handleDeleteWord, isError }) {
    return (
        <div className={styles.useWordCont}>
            <div className={styles.useWordGroup}>
            <p className={styles.useWordP} style={isError ? {color: 'red'} : {}}>{useWord}</p>
            {updateMode[id] ? (
                <button onClick={() => handleDeleteWord(id, index)} className={styles.closeButton}>
                    <IoIosClose className={styles.closeIcon} />
                </button>
            ) : null}
            </div>
        </div>
    );
}

